<template>
    <div class="key-data-sup-base-info">
        <div class="title-container">
            <span class="sub-title">供应商基础信息</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-if="contentVisible">
            <el-row>
                <el-col class="has-bg right-text" :span="3">供应商编码</el-col>
                <el-col :span="5">{{ formData.supplierCode }}</el-col>
                <el-col class="has-bg right-text" :span="3">供应商名称</el-col>
                <el-col :span="5">{{ formData.supplierNameCn }}</el-col>
                <el-col class="has-bg right-text" :span="3">供应商类型</el-col>
                <el-col :span="5">{{ formData.supplierType }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">主体性质</el-col>
                <el-col :span="5">{{ formData.propertyNature }}</el-col>
                <el-col class="has-bg right-text" :span="3">业务类型</el-col>
                <el-col :span="5">{{ formData._businessType }}</el-col>
                <el-col class="has-bg right-text" :span="3">涉外业务类型</el-col>
                <el-col :span="5">{{ formData.isOverseas }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">承运商类别</el-col>
                <el-col :span="5">{{ formData.transType }}</el-col>
                <el-col class="has-bg right-text" :span="3">运输方式</el-col>
                <el-col :span="5">{{ formData.transportType }}</el-col>
                <el-col class="has-bg right-text" :span="3">业务类型状态</el-col>
                <el-col :span="5">{{ formData.businessTypeStatus }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">租赁商类别</el-col>
                <el-col :span="5">{{ formData.lesseeType }}</el-col>
                <el-col class="has-bg right-text" :span="3">法定代表人</el-col>
                <el-col :span="5">{{ formData.corporateName }}</el-col>
                <el-col class="has-bg right-text" :span="3">负责人</el-col>
                <el-col :span="5">{{ formData.principalName }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">身份证号码</el-col>
                <el-col :span="5">{{ formData.idCard }}</el-col>
                <el-col class="has-bg right-text" :span="3">社会信用代码</el-col>
                <el-col :span="5">{{ formData.societyCreditCode }}</el-col>
                <el-col class="has-bg right-text" :span="3">合作方式</el-col>
                <el-col :span="5">{{ formData.corporateType }}</el-col>
            </el-row>
            <el-row class="wrap-label-row">
                <el-col class="has-bg right-text" :span="3">营业执照注册起始日期</el-col>
                <el-col :span="5">{{ formData.businessLicenseDateFrom }}</el-col>
                <el-col class="has-bg right-text" :span="3">营业执照注册终止日期</el-col>
                <el-col :span="5">{{ formData.businessLicenseDateTo }}</el-col>
                <el-col class="has-bg right-text" :span="3">成立日期</el-col>
                <el-col :span="5">{{ formData.registerDate }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text no-wrap" :span="3">注册资金（万元）</el-col>
                <el-col :span="5">{{ formData.registerCapital }}</el-col>
                <el-col class="has-bg right-text" :span="3">是否特批</el-col>
                <el-col :span="5">{{ formData.specialFlag }}</el-col>
                <el-col class="has-bg right-text" :span="3">企业注册地址</el-col>
                <el-col ref="addressColRef" :span="5">{{ formData.address }}</el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="3">资质信息</el-col>
                <el-col :span="21" ref="qlfColRef">
                    <el-button class="preview-btn" v-for="item in qualificationList" :key="item.id" type="text" @click="handlePreview(item)">{{ item.qualificationName }}</el-button>
                </el-col>
            </el-row>
            <!-- 引入审批： srm_register_mip_approval -->
            <el-row v-if="moduleCode === 'srm_register_mip_approval' && isTransportationDelivery">
                <el-col class="has-bg right-text" :span="3">风险预警</el-col>
                <el-col :span="21">
                    <div>
                        {{ warningTags }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import { dictWithUrl } from '@/components/lots/api'
import { getSupplierInfo, getSupplierWarningTagsByIFlow } from '../../../../../../api/keyDataDetail.js'
import { getManageTreeData } from '../../../../../../api/qualification.js'
import Preview from '../../../../../../components/viewAttachment.vue';

export default {
    components: { Preview },
    props: {
        supplierParams: {
            type: Object,
            default: () => {
                return {
                    id: '',
                    businessType: '',
                    supplierCode: '',
                    propertyNature: '',
                }
            }
        },
        auditId: {
            type: String,
            default: ''
        },
        moduleCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            contentVisible: true,
            dictData: {},
            formData: {
                supplierCode: '-',
                supplierNameCn: '-',
                supplierType: '-',
                propertyNature: '-',
                _businessType: '-',
                businessType: '-',
                businessTypeStatus: '-',
                transType: '-',
                transportType: '-',
                corporateType: '-',
                lesseeType: '-',
                corporateName: '-',
                principalName: '-',
                idCard: '-',
                societyCreditCode: '-',
                registerDate: '-',
                businessLicenseDateFrom: '-',
                businessLicenseDateTo: '-',
                address: '-',
                registerCapital: '-',
                specialFlag: '-',
            },
            qualificationList: [],
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
            warningTags: '',
        };
    },
    computed: {
        // 判断业务类型是否是运输和配送
        isTransportationDelivery(){
            //3 : 运输，4: 配送
            if(['3', '4'].includes(this.formData.businessType)) {
                return true;
            }
            return false;
        }
    },
    methods: {
        getWarNingTags(){
            // let fdid = this.rowData.fdId;''
            if(!this.auditId){
                return false;
            }
            getSupplierWarningTagsByIFlow(this.auditId).then(res => {
                if (res && res.code === '0') {
                    const { waringTabs } = res.data;
                    if(Array.isArray(waringTabs)){
                        let dataList = [];
                         let warningDic = this.dictData.SYS_DOCUMENT_EARLY_WARNING_TYPE;
                        for (const item of waringTabs) {
                            dataList.push(warningDic[item]);
                        }
                        this.warningTags =dataList.join('，');
                       
                    }else{
                        this.warningTags = '';
                    }
                }
            })
        },
        loadData() {
            getSupplierInfo(this.supplierParams).then(res => {
                if (res && +res.code === 0) {
                    if(res.data.supplierType === '70'){
                        //当供应商类型=物流供应商，需要显示常跑线路
                        this.$emit('showLine')
                    }
                    this.setFormData(res.data)
                    // 供应商引入以及业务类型是运输和配送才查询预警
                    if(this.moduleCode === 'srm_register_mip_approval' && this.isTransportationDelivery){
                        this.getWarNingTags()
                    }
                }
            }).catch(err => {})
            getManageTreeData({
                supplierCode: this.supplierParams.supplierCode,
                businessType: this.supplierParams.businessType,
            }).then(res => {
                if (res && +res.code === 0) {
                    this.setQualificationList(res.data)
                }
            }).catch(err => {})
        },
        setFormData(data) {
            this.formData.supplierCode = data.supplierCode || '-'
            this.formData.supplierNameCn = data.supplierNameCn || '-'
            this.formData.supplierType = this.dictData.SYS_SUPPLIERS_TYPE[data.supplierType] || '-'
            this.formData.propertyNature = this.dictData.SYS_SUPPLIERS_PROPERTY[data.propertyNature] || '-'
            this.formData._businessType = this.dictData.SRM_BUSYNESS_TYPE_BACKGROUND[data.businessType] || '-'
            this.formData.businessType = data.businessType || '-'
            this.formData.isOverseas = this.dictData.SRM_IS_OVERSEAS[data.isOverseas] || '-'
            this.formData.businessTypeStatus = this.dictData.SYS_SUPPLIER_SERVICES_STATUS[data.businessTypeStatus] || '-'
            this.formData.transType = this.dictData.SRM_SHIPPER_TYPE[data.transType] || '-'
            this.formData.transportType = this.dictData.SRM_TRANSPORT_TYPE[data.transportType] || '-'
            this.formData.corporateType = this.dictData.SU_CORPORATE_TYPE[data.corporateType] || '-'
            this.formData.lesseeType = this.dictData.SU_LEASE_TYPE[data.lesseeType] || '-'
            this.formData.corporateName = data.needShowBasicInfo.corporateName || '-'
            this.formData.principalName = data.needShowBasicInfo.principalName || '-'
            this.formData.idCard = data.needShowBasicInfo.idCard || '-'
            this.formData.societyCreditCode = data.needShowBasicInfo.societyCreditCode || '-'
            this.formData.registerDate = this.timeformat(data.needShowBasicInfo.registerDate)
            this.formData.businessLicenseDateFrom = this.timeformat(data.needShowBasicInfo.businessLicenseDateFrom)
            this.formData.businessLicenseDateTo = this.timeformat(data.needShowBasicInfo.businessLicenseDateTo)
            this.formData.address = data.needShowBasicInfo.address || '-'
            this.formData.registerCapital = data.needShowBasicInfo.registerCapital || '-'
            this.formData.specialFlag = this.dictData.SRM_SPECIAL_FLAG[data.specialFlag] || '-'
        },
        timeformat(time) {
            return time ? dayjs(time).format('YYYY-MM-DD') : '-'
        },
        setQualificationList(data) {
            const qualificationList = []
            const attachmentList = []
            if (data && data.length) {
                const baseQualification = data.find(item => item.title === '基本资质')
                if (baseQualification && baseQualification.children && baseQualification.children.length) {
                    baseQualification.children.forEach(child => {
                        if (child.temFileUrl) {
                            qualificationList.push({
                                id: child.id,
                                qualificationName: child.qualificationName,
                                temFileUrl: child.temFileUrl,
                                fileName: child.fileName,
                                fileId: child.fileId,
                            })
                        }
                        attachmentList.push(child.temFileUrl)
                    })
                }
            }
            this.qualificationList = qualificationList
            this.attachmentList = attachmentList.filter(item => !!item)
        },
        handlePreview(data) {
            this.rowData = {
                downUrl: data.temFileUrl,
                fileName: data.fileName,
                fileId: data.fileId
            };
            this.attachmentShow = true;
        },
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
    },
    mounted() {
        // 证件预警类型  SYS_DOCUMENT_EARLY_WARNING_TYPE
        dictWithUrl('SYS_SUPPLIERS_TYPE,SYS_SUPPLIERS_PROPERTY,SRM_BUSYNESS_TYPE_BACKGROUND,SRM_IS_OVERSEAS,SYS_SUPPLIER_SERVICES_STATUS,SRM_SHIPPER_TYPE,SRM_TRANSPORT_TYPE,SU_CORPORATE_TYPE,SU_LEASE_TYPE,SRM_SPECIAL_FLAG,SYS_DOCUMENT_EARLY_WARNING_TYPE').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                this.loadData()
            }
        }).catch(err => {})
        window.addEventListener('resize', this.rowHeightResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.rowHeightResize)
    }
};
</script>
<style lang="less">
.key-data-sup-base-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-bottom: 5px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        background: #f5f7fa;
    }

    .right-text {
        text-align: right;
    }
    
    .el-row {
        display: flex;
        width: 100%;
    }

    .el-col {
        padding: 5px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        min-height: 30px;
    }


    .wrap-label-row .el-col {
        min-height: 50px;
    }

    .no-wrap {
        white-space: nowrap;
    }

    .preview-btn {
        padding: 0;
    }
}
</style>
